
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"x1":"128.318%","y1":"23.73%","x2":"0%","y2":"57.031%","id":"a"}},[_c('stop',{attrs:{"stop-color":"#75F0A0","offset":"0%"}}),_c('stop',{attrs:{"stop-color":"#4BACE5","offset":"100%"}})]),_c('linearGradient',{attrs:{"x1":"128.318%","y1":"-136.808%","x2":"0%","y2":"100%","id":"b"}},[_c('stop',{attrs:{"stop-color":"#75F0A0","offset":"0%"}}),_c('stop',{attrs:{"stop-color":"#4BACE5","offset":"100%"}})]),_c('linearGradient',{attrs:{"x1":"70.456%","y1":"-136.808%","x2":"36.94%","y2":"100%","id":"c"}},[_c('stop',{attrs:{"stop-color":"#75F0A0","offset":"0%"}}),_c('stop',{attrs:{"stop-color":"#4BACE5","offset":"100%"}})]),_c('linearGradient',{attrs:{"x1":"61.797%","y1":"-136.808%","x2":"42.469%","y2":"100%","id":"d"}},[_c('stop',{attrs:{"stop-color":"#75F0A0","offset":"0%"}}),_c('stop',{attrs:{"stop-color":"#4BACE5","offset":"100%"}})])]),_c('g',{attrs:{"stroke-width":"1.833","stroke-linecap":"round","stroke-linejoin":"round","transform":"translate(-1 -3)","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M16.667 20.5v-1.833A3.667 3.667 0 0013 15H5.667A3.667 3.667 0 002 18.667V20.5","stroke":"url(#a)"}}),_c('circle',{attrs:{"stroke":"url(#b)","cx":"9.333","cy":"7.667","r":"3.667"}}),_c('path',{attrs:{"d":"M22.167 20.5v-1.833a3.667 3.667 0 00-2.75-3.548","stroke":"url(#c)"}}),_c('path',{attrs:{"d":"M15.75 4.12a3.667 3.667 0 010 7.103","stroke":"url(#d)"}})])])
          )
        }
      }
    